import { styled } from '@material-ui/core/styles'

// An inline block moves to the next line as a unit, and still wraps inside itself when it's wider than the line.
export const Phrase = styled('span')({
  display: 'inline-block',
})
